import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

const Arrow = ({ dir, stroke, onClick }) => {
  return (
    <svg
      x='0px'
      y='0px'
      stroke={stroke}
      viewBox='0 0 14 8'
      xmlSpace='preserve'
      fill='none'
      className={`menu-arrow generic-arrow generic-arrow-${dir}`}
      onClick={onClick}
    >
      <path d='M1,1l6.2,6L13,1' />
    </svg>
  )
}

Arrow.propTypes = {
  dir: PropTypes.string,
  stroke: PropTypes.string,
  onClick: PropTypes.func
}

export default Arrow
